var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValve = function SvgValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 7.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M23 16H9M16 9v14"
  })));
};
export { SvgValve as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='16' cy='16' r='7.25' stroke='%234A6067' stroke-width='1.5'/%3e %3cline x1='23' y1='16' x2='9' y2='16' stroke='%234A6067' stroke-width='2' stroke-linecap='round'/%3e %3cline x1='16' y1='9' x2='16' y2='23' stroke='%234A6067' stroke-width='2' stroke-linecap='round'/%3e %3c/svg%3e";